// ===============================
// Variable Assign
// ===============================
const pincodeCheckerButton = $("#inputValueCheck");
const pincodeCheckerError = $("#pincodeError");
const pincodeCheckerProductData = $("#pincodeCheckerProductData");
// const pincodeCheckerUrlFetch =
//   "https://admin.nilkamalfurniture.com/api/get-pincodecheckerdata";
const pincodeCheckerUrlFetch =
  "https://admin.nilkamalfurniture.com/api/get-pincodecheckerdata-test";
const pincodeCheckerWorkingAtc = $(".my__custom__atc"); // ✅ Updated class
const pincodeCheckerNotWorkingAtc = $('[data-atc="dummy__button_one"]');
const pincodeCheckerWorkingBuyBtn = $('[data-shopify="payment-button"]');
const pincodeCheckerNotWorkingBuyBtn = $('[data-buyatc="payment_button_one"]');
const pincodeCheckerBtnLoader = $(".responseLoader");
const pincodeCheckerDefaultPincode = 400028;
const pincodeCheckerInput = $("#pincodeSearch");
const inputContainer = $(".pincode__checker__html .input__container");
const locationIcon = $(".location__icon__svg svg path");
console.log("Location", locationIcon)
let apiError = false;
let apiSuccess = false;

// ===============================
// Helper (✅ FINAL FIXED VERSION)
// ===============================
// function toggleButtonState(isWorking) {
//   // Step 1: Hide all buttons forcibly
//   $(".my__custom__atc, [data-atc='dummy__button_one'], [data-shopify='payment-button'], [data-buyatc='payment_button_one']")
//     .each(function () {
//       this.style.setProperty("display", "none", "important");
//     });

//   $(".shopify-payment-button__button").each(function () {
//     this.style.setProperty("display", "none", "important");
//   });

//   // Step 2: Show only correct buttons
//   if (isWorking) {
//     // ✅ Working buttons visible
//     $(".my__custom__atc").each(function () {
//       this.style.setProperty("display", "block", "important");
//     });

//     $("[data-shopify='payment-button']").each(function () {
//       this.style.setProperty("display", "block", "important");
//     });

//     $(".shopify-payment-button__button").each(function () {
//       this.style.setProperty("display", "block", "important");
//     });
//   } else {
//     // ❌ Dummy buttons visible
//     $("[data-atc='dummy__button_one']").each(function () {
//       this.style.setProperty("display", "block", "important");
//     });

//     $("[data-buyatc='payment_button_one']").each(function () {
//       this.style.setProperty("display", "block", "important");
//     });
//   }
// }

// ===============================
// Helper (✅ FINAL + MOBILE FIX VERSION)
// ===============================
function toggleButtonState(isWorking) {
  const isMobile = window.innerWidth <= 768; // ✅ Detect mobile screen width

  // Step 1: Hide all buttons forcibly
  $(
    ".my__custom__atc, [data-atc='dummy__button_one'], [data-shopify='payment-button'], [data-buyatc='payment_button_one']"
  ).each(function () {
    this.style.setProperty("display", "none", "important");
  });

  $(".shopify-payment-button__button").each(function () {
    this.style.setProperty("display", "none", "important");
  });

  // Step 2: Show only correct buttons
  if (isWorking) {
    // ✅ Working buttons visible
    $(".my__custom__atc").each(function () {
      this.style.setProperty("display", "block", "important");
    });

    // ✅ Buy button hide for mobile
    if (!isMobile) {
      $("[data-shopify='payment-button']").each(function () {
        this.style.setProperty("display", "block", "important");
      });

      $(".shopify-payment-button__button").each(function () {
        this.style.setProperty("display", "block", "important");
      });
    }
  } else {
    // ❌ Dummy buttons visible
    $("[data-atc='dummy__button_one']").each(function () {
      this.style.setProperty("display", "block", "important");
    });

    // ✅ Buy dummy button hide for mobile
    if (!isMobile) {
      $("[data-buyatc='payment_button_one']").each(function () {
        this.style.setProperty("display", "block", "important");
      });
    }
  }
}

// ===============================
// Run API
// ===============================
// function runApi(pincode, qty = 1, selectedVariant = null) {
//   const productData = JSON.parse(pincodeCheckerProductData.text());
//   const variants = productData.variants;

//   toggleButtonState(false); // Hide working buttons initially

//   let variantToCheck = selectedVariant;
//   if (!variantToCheck) {
//     const urlVariant = new URLSearchParams(window.location.search).get(
//       "variant"
//     );
//     variantToCheck = variants.find((v) => v.id == urlVariant) || variants[0];
//   }

//   if (!variantToCheck) {
//     console.warn("❌ No valid variant found for API");
//     return;
//   }

//   fetchData({
//     pincode,
//     sku: variantToCheck.sku,
//     qty,
//     sku_qty: variantToCheck.inventory_quantity,
//     sku_available: variantToCheck.available,
//     product_type: productData.productType,
//   });
// }
function runApi(pincode, qty, selectedVariant = null) {
  const productData = JSON.parse(pincodeCheckerProductData.text());
  const variants = productData.variants;
  const selectedVariantOnLoad = productData.selectedVariant;
  const selecedVariantAvailableOnload =
    productData.selectedVariantAvailable;
  const selecedVariantAvailableSkuOnload = productData.selecedVariantAvailableSku;
  const selectedVariantWarehouseCodeOnload = productData.selectedVariantWarehouseCode;
  const selectedVariantDeliveryDaysOnload = productData.selectedVariantDeliveryDays;

  toggleButtonState(false); // Hide working buttons initially

  let variantToCheck = selectedVariant;
  const urlVariant = new URLSearchParams(window.location.search).get("variant");

  if (!variantToCheck) {
    variantToCheck = variants.find(v => v.id == urlVariant) || variants[0];
  }

  if (!variantToCheck) {
    console.warn("❌ No valid variant found for API");
    return;
  }

  fetchData({
    pincode,
    sku: urlVariant ? variantToCheck.sku : selectedVariantOnLoad,
    qty,
    sku_qty: urlVariant ? variantToCheck.inventory_quantity : selecedVariantAvailableSkuOnload,
    sku_available: urlVariant
      ? variantToCheck.available
      : selecedVariantAvailableOnload,
    product_type: productData.productType,
    designated_delivery_days : urlVariant ? variantToCheck.deliveryDays : selectedVariantDeliveryDaysOnload,
    default_designated_warehouse : urlVariant ? variantToCheck.warehouseCode : selectedVariantWarehouseCodeOnload
  });
}

// ===============================
// Ajax
// ===============================
function fetchData({
  pincode,
  sku,
  qty,
  sku_qty,
  sku_available,
  product_type,
  designated_delivery_days,
  default_designated_warehouse
}) {
  const bodyData = { pincode, sku, qty, sku_qty, sku_available, product_type , designated_delivery_days , default_designated_warehouse };

  pincodeCheckerButton.hide();
  pincodeCheckerBtnLoader.show();

  $.ajax({
    url: pincodeCheckerUrlFetch,
    type: "POST",
    data: bodyData,
    dataType: "json",
    success: function (data) {
      pincodeCheckerBtnLoader.hide();
      pincodeCheckerButton.show();

      if (data.success) {
        apiError = false;
        apiSuccess = true;
        locationIcon.attr({
          "fill": "black",
          "fill-opacity": "0.6"
        });

        convertResponseInObject(data);
        inputContainer.removeClass("container__error");
        // ✅ Show working buttons only
        toggleButtonState(true);
      } else {
        apiError = true;
        apiSuccess = false;
        inputContainer.addClass("container__error");

        // ✅ CHECK: Pincode not serviceable vs Product sold out
        const htmlContent = data.data || "";
        const isPincodeNotServiceable = htmlContent.includes("This pincode is not serviceable");

        if (isPincodeNotServiceable) {
          // 🔴 Pincode not serviceable error
          pincodeCheckerError.html(`
            <div class="apiResponse">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="9" fill="#D80000" fill-opacity="1"></circle>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77271 3.68182V10.2273H10.2273V3.68182H7.77271ZM7.77271 11.8636V14.3182H10.2273V11.8636H7.77271Z" fill="white"></path>
              </svg>
              <span class="error-text" style="color:red;">Pincode is not serviceable</span>
            </div>
          `);
        } else {
          // 🔴 Product sold out error
          pincodeCheckerError.html(`
            <div class="apiResponse">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="9" fill="#D80000" fill-opacity="1"></circle>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77271 3.68182V10.2273H10.2273V3.68182H7.77271ZM7.77271 11.8636V14.3182H10.2273V11.8636H7.77271Z" fill="white"></path>
              </svg>
              <span class="error-text" style="color:red;">This product is sold out</span>
            </div>
          `);
        }

        // ❌ Show dummy buttons only
        toggleButtonState(false);
        locationIcon.attr({
          "fill": "#D80000",
          "fill-opacity": "1"
        });
      }
    },
    error: function () {
      apiError = true;
      apiSuccess = false;
      toggleButtonState(false);
      locationIcon.attr({
        "fill": "#D80000",
        "fill-opacity": "1"
      });
    },
  });
}

// ===============================
// Convert Response
// ===============================
function convertResponseInObject(data) {
  const html = $("<div>").html(data.data);
  const table = html.find("table");
  if (!table.length) return;

  const json = {};
  table.find("tr").each(function (r) {
    const rowData = {};
    $(this)
      .find("th, td")
      .each(function (c) {
        const text = $(this).text().trim();
        const img = $(this).find("img").attr("src");
        const link = $(this).find("a");
        const date = $(this).find(".date").text().trim();

        if (text) rowData[`col_${r}_${c}`] = text;
        if (img) rowData[`col_${r}_${c}_img`] = img;
        if (link.length)
          rowData[`col_${r}_${c}_link`] = {
            href: link.attr("href"),
            onclick: link.attr("onclick"),
            text: link.text().trim(),
          };
        if (date) rowData[`col_${r}_${c}_date`] = date;
      });
    if (Object.keys(rowData).length) json[`row_${r}`] = rowData;
  });

  displayResponse(json);
}

function displayResponse(res) {
  


  const date = res.row_1?.col_1_0_date || "";
  const img = res.row_1?.col_1_0_img || "";
  let shippingCharge = res.row_2?.col_2_0 || "";
  const wantDateFormate = formatDeliveryDate(date);

  let html = `<div class="apiResponse">`;
  html += `<div class="deliveryResponse"><p>`;

  // ======================================
  // CLEAN SHIPPING CHARGE TEXT
  // ======================================
  let finalShippingText = "";
  // if (shippingCharge) {
  //   // Extract only amount
  //   const amountMatch = shippingCharge.match(/₹\s*\d+/);
  //   const amount = amountMatch ? amountMatch[0] : "";

  //   finalShippingText = `<span>Delivery Charge:</span> <span style="font-weight : 700;">${amount}</span>`;
  // }

  if (shippingCharge) {
    // Extract only amount (just numbers)
    const amountMatch = shippingCharge.match(/\d+/);
    const amount = amountMatch ? amountMatch[0] : "";

    // Rupees Icon (custom span)
    const rupeesIcon = `<span class="Pincode__rupees__icon" style="font-weight : 700;">₹</span>`;

    finalShippingText = `
      <span>Delivery :</span> 
      ${rupeesIcon}
      <span class="shipping_amount" style="font-weight:700; margin-left:-4px;">${amount}</span>
  `;
  }

  // ==========================
  // CASE 1: FREE SHIPPING
  // ==========================
  if (!shippingCharge) {
    if (img)
      html += ` 
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9000_329)">
<path d="M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM6 18.5C5.17 18.5 4.5 17.83 4.5 17C4.5 16.17 5.17 15.5 6 15.5C6.83 15.5 7.5 16.17 7.5 17C7.5 17.83 6.83 18.5 6 18.5ZM19.5 9.5L21.46 12H17V9.5H19.5ZM18 18.5C17.17 18.5 16.5 17.83 16.5 17C16.5 16.17 17.17 15.5 18 15.5C18.83 15.5 19.5 16.17 19.5 17C19.5 17.83 18.83 18.5 18 18.5Z" fill="#007D1B" fill-opacity="0.83"/>
</g>
<defs>
<clipPath id="clip0_9000_329">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg> `;

    html += `<span class="message_free_shipping">FREE DELIVERY</span>`;

    html += `<span class="delivery_date">${wantDateFormate}</span>`;
  }

  // ==========================
  // CASE 2: SHIPPING CHARGE
  // ==========================
  else {
    html += `<span class="message_shipping_charge">${finalShippingText}</span>`;

    if (img)
      html += ` 
<svg width="24" height="24" style="margin-left : 12px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9000_329)">
<path d="M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM6 18.5C5.17 18.5 4.5 17.83 4.5 17C4.5 16.17 5.17 15.5 6 15.5C6.83 15.5 7.5 16.17 7.5 17C7.5 17.83 6.83 18.5 6 18.5ZM19.5 9.5L21.46 12H17V9.5H19.5ZM18 18.5C17.17 18.5 16.5 17.83 16.5 17C16.5 16.17 17.17 15.5 18 15.5C18.83 15.5 19.5 16.17 19.5 17C19.5 17.83 18.83 18.5 18 18.5Z" fill="#007D1B" fill-opacity="0.83"/>
</g>
<defs>
<clipPath id="clip0_9000_329">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg> `;

    html += `<span class="delivery_date" style="margin-left:4px !important;">${wantDateFormate}</span>`;
  }

  html += `</p></div></div>`;

  pincodeCheckerError.html(html);
}

// ===============================
// Init
// ===============================
function pincodeCheckerInit() {
  let storedPin =
    localStorage.getItem("pincodeChecker") || pincodeCheckerDefaultPincode;
  localStorage.setItem("pincodeChecker", storedPin);
  pincodeCheckerInput.val(storedPin);

  const qtyValue = $('#quantity').val().trim();
    // console.log("qtyValue" , qtyValue);

  if (String(storedPin).length === 6) runApi(storedPin , qtyValue);
}

// ===============================
// Input Events
// ===============================
// function pincodeCheckerEventInit() {
//   pincodeCheckerInput.on("input", function () {
//     this.value = this.value.replace(/\D/g, "").slice(0, 6);
//     const val = this.value.trim();
//     apiError = false;
//     apiSuccess = false;

//     if (val.length === 6) {
//       inputContainer.removeClass("container__error");
//       pincodeCheckerError.empty();
//       localStorage.setItem("pincodeChecker", val);
//       runApi(val);
//     }
//   });

//   pincodeCheckerInput.on("blur", function () {
//     const val = this.value.trim();

//     if (!val) {
//       inputContainer
//         .addClass("container__error")
//         .css("animation", "shake 0.3s");
//       pincodeCheckerError.html(`
//         <div class="apiResponse">

// <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g clip-path="url(#clip0_6258_2920)">
// <rect width="18" height="18" fill="white"/>
// <circle cx="9" cy="9" r="9" fill="#D80000" fill-opacity="0.63"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77271 3.68182V10.2273H10.2273V3.68182H7.77271ZM7.77271 11.8636V14.3182H10.2273V11.8636H7.77271Z" fill="white"/>
// </g>
// <defs>
// <clipPath id="clip0_6258_2920">
// <rect width="18" height="18" fill="white"/>
// </clipPath>
// </defs>
// </svg>

//           <span class="error-text" style="color:red;">Please enter pincode to continue</span>
//         </div>
//       `);
//       toggleButtonState(false);
//       return;
//     }

//     if (val.length < 6) {
//       inputContainer
//         .addClass("container__error")
//         .css("animation", "shake 0.3s");
//       pincodeCheckerError.html(`
//         <div class="apiResponse">

// <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g clip-path="url(#clip0_6258_2920)">
// <rect width="18" height="18" fill="white"/>
// <circle cx="9" cy="9" r="9" fill="#D80000" fill-opacity="0.63"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77271 3.68182V10.2273H10.2273V3.68182H7.77271ZM7.77271 11.8636V14.3182H10.2273V11.8636H7.77271Z" fill="white"/>
// </g>
// <defs>
// <clipPath id="clip0_6258_2920">
// <rect width="18" height="18" fill="white"/>
// </clipPath>
// </defs>
// </svg>

//           <span class="error-text" style="color:red;">Please enter Valid 6 digit Pincode</span>
//         </div>
//       `);
//       toggleButtonState(false);
//       return;
//     }

//     inputContainer.removeClass("container__error");
//   });

//   pincodeCheckerButton.on("click", function () {
//     const pin = pincodeCheckerInput.val().trim().replace(/\D/g, "").slice(0, 6);
//     pincodeCheckerInput.val(pin);
//     apiError = false;
//     apiSuccess = false;

//     if (!pin) {
//       inputContainer
//         .addClass("container__error")
//         .css("animation", "shake 0.3s");
//       pincodeCheckerError.html(`
//         <div class="apiResponse">

// <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g clip-path="url(#clip0_6258_2920)">
// <rect width="18" height="18" fill="white"/>
// <circle cx="9" cy="9" r="9" fill="#D80000" fill-opacity="0.63"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77271 3.68182V10.2273H10.2273V3.68182H7.77271ZM7.77271 11.8636V14.3182H10.2273V11.8636H7.77271Z" fill="white"/>
// </g>
// <defs>
// <clipPath id="clip0_6258_2920">
// <rect width="18" height="18" fill="white"/>
// </clipPath>
// </defs>
// </svg>

//           <span class="error-text" style="color:red;">Please enter pincode to continue</span>
//         </div>
//       `);
//       toggleButtonState(false);
//       return;
//     }

//     if (pin.length !== 6) {
//       inputContainer
//         .addClass("container__error")
//         .css("animation", "shake 0.3s");
//       pincodeCheckerError.html(`
//         <div class="apiResponse">

// <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g clip-path="url(#clip0_6258_2920)">
// <rect width="18" height="18" fill="white"/>
// <circle cx="9" cy="9" r="9" fill="#D80000" fill-opacity="0.63"/>
// <path fill-rule="evenodd" clip-rule="evenodd" d="M7.77271 3.68182V10.2273H10.2273V3.68182H7.77271ZM7.77271 11.8636V14.3182H10.2273V11.8636H7.77271Z" fill="white"/>
// </g>
// <defs>
// <clipPath id="clip0_6258_2920">
// <rect width="18" height="18" fill="white"/>
// </clipPath>
// </defs>
// </svg>

//           <span class="error-text" style="color:red;">Please enter Valid 6 digit Pincode</span>
//         </div>
//       `);
//       toggleButtonState(false);
//       return;
//     }

//     inputContainer.removeClass("container__error");
//     localStorage.setItem("pincodeChecker", pin);
//     runApi(pin);
//   });
// }

function pincodeCheckerEventInit() {
  let lastApiPin = ""; // Track last API pin

  // ===========================
  // INPUT EVENT
  // ===========================
  pincodeCheckerInput.on("input", function () {
    // Only numbers, max 6
    this.value = this.value.replace(/\D/g, "").slice(0, 6);

    const val = this.value.trim();

    apiError = false;
    apiSuccess = false;

    // ❌ Reset if blank or less than 6
    if (val.length < 6) {
      lastApiPin = ""; // IMPORTANT FIX
      return;
    }

    // 6 digits → run API ONLY if new pincode
    if (val.length === 6 && val !== lastApiPin) {
      lastApiPin = val;
      const qtyValue = $('#quantity').val().trim();
    // console.log("qtyValue" , qtyValue);
      inputContainer.removeClass("container__error");
      pincodeCheckerError.empty();
      localStorage.setItem("pincodeChecker", val);

      runApi(val , qtyValue);
    }
  });

  // ===========================
  // BLUR EVENT
  // ===========================
  pincodeCheckerInput.on("blur", function () {
    const val = this.value.trim();

    // Blank input
    if (!val) {
      showError("Please enter pincode to continue");
      toggleButtonState(false);
      lastApiPin = ""; // FIX
      return;
    }

    // Less than 6 digits
    if (val.length < 6) {
      showError("Please enter pincode to continue");
      toggleButtonState(false);
      lastApiPin = ""; // FIX
      return;
    }

    inputContainer.removeClass("container__error");
  });

  // ===========================
  // BUTTON CLICK
  // ===========================
  pincodeCheckerButton.on("click", function () {
    const pin = pincodeCheckerInput.val().trim().replace(/\D/g, "").slice(0, 6);
    pincodeCheckerInput.val(pin);
    const qtyValue = $('#quantity').val().trim();
    // console.log("qtyValue" , qtyValue);
    apiError = false;
    apiSuccess = false;

    if (!pin) {
      showError("Please enter pincode to continue");
      toggleButtonState(false);
      lastApiPin = ""; // FIX
      return;
    }

    if (pin.length !== 6) {
      showError("Please enter Valid 6 digit Pincode");
      toggleButtonState(false);
      lastApiPin = ""; // FIX
      return;
    }

    // Allow API again for same pincode (important)
    lastApiPin = ""; // SO BUTTON ALWAYS WORKS

    inputContainer.removeClass("container__error");
    localStorage.setItem("pincodeChecker", pin);

    runApi(pin , qtyValue);
  });
}



// ===============================
// Quantity Events
// ===============================
function onQuantityPincodeCheck() {
  const qtyInput = $("#quantity");

  $('[data-func="plus"]').on("click", function () {
    const val = parseInt(qtyInput.val()) + 1;
    if (pincodeCheckerInput.val().trim().length === 6)
      runApi(pincodeCheckerInput.val(), val);
  });

  $('[data-func="minus"]').on("click", function () {
    const val = Math.max(parseInt(qtyInput.val()) - 1, 1);
    if (pincodeCheckerInput.val().trim().length === 6)
      runApi(pincodeCheckerInput.val(), val);
  });

  qtyInput.on("focusout", function () {
    const val = parseInt(qtyInput.val());
    if (pincodeCheckerInput.val().trim().length === 6)
      runApi(pincodeCheckerInput.val(), val);
  });
}

// ===============================
// Variant Change Events
// ===============================
function onVariantChangePincodeCheck() {
  $(".multi_sel.binaryic").on("change", function () {
    const productData = JSON.parse(pincodeCheckerProductData.text());
    const variants = productData.variants;
    const urlParams = new URLSearchParams(window.location.search);
    const qtyValue = $('#quantity').val().trim();
    // console.log("qtyValue" , qtyValue);
    const variantId = urlParams.get("variant");
    const currentPincode =
      pincodeCheckerInput.val().trim() ||
      localStorage.getItem("pincodeChecker");

    if (variantId && currentPincode?.length === 6) {
      const selectedVariant = variants.find((v) => v.id == variantId);
      if (selectedVariant) {
        console.log("✅ Variant changed:", selectedVariant.sku);
        runApi(currentPincode, qtyValue, selectedVariant);
      }
    }
  });
}

function onCheckoutButtonsInit() {
  document
    .querySelectorAll(
      'magic-checkout-btn[page-type="product"], magic-checkout-btn[page-type="cart"]'
    )
    .forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const pageType = e.currentTarget.getAttribute("page-type")?.trim("");

        if (pageType === "product" && apiSuccess) {
          window.onBuyNowClickMagic(e);
        }

        if (pageType === "cart") {
          window.openRzpCheckout(e);
        }
      });
    });
}


// ===============================
// Scroll to Input on Click
// ==============================

function onclickScrollTopToInput() {
  const disabledButtons = $(
    '[data-atc="dummy__button_one"], [data-buyatc="payment_button_one"]'
  );

  disabledButtons.on('click', function (e) {
    e.preventDefault();

    const box = $(".input__container");

    $('html, body').animate({
      scrollTop: $(".form-box").offset().top - 100
    }, 500, function () {

      // ❗ Remove inline animation first
      box.css("animation", "none");

      // ❗ Force reflow (browser restart animation)
      void box[0].offsetWidth;

      // 🔥 Now apply shake class
      box.addClass("shake-animation");

      setTimeout(() => {
        box.removeClass("shake-animation");
        box.css("animation", ""); // reset inline style
      }, 400);
    });
  });
}


function customddataEvent() {
  pincodeCheckerInput.on("keydown", function (e) {
    if (e.key === "Enter") {
      const val = this.value.trim().replace(/\D/g, "");

      e.preventDefault(); // STOP ENTER ALWAYS

      // Less than 6 → Show error
      if (val.length < 6) {
        showError("Please enter pincode to continue");
        toggleButtonState(false);
        $("#pincodeSearch").focus();   // focus works fine
        return false;
      }

      // Exactly 6 → Do NOT run API, just block Enter
      return false;
    }
  });

  $('#quantity').on("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault()
    }
  })

   pincodeCheckerInput.on("wheel", function (e) {
    e.preventDefault();  // stops scroll changing input
    this.blur();         // optional → remove focus when scroll is used
  });

  $("#quantity").on("wheel", function (e) {
    e.preventDefault();
    this.blur();
  });

  pincodeCheckerInput.on("keydown", function (e) {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  });

  $("#quantity").on("keydown", function (e) {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  });
}

// function formatDeliveryDate(rawDate) {
//   if (!rawDate) return "";

//   // Split: "2nd Dec, 2025"
//   const [datePart, monthPartYear] = rawDate.split(" ");
  
//   const dateNumber = datePart.replace(/(st|nd|rd|th)/, ""); // remove st/nd/rd/th for parsing
//   const monthName = monthPartYear.replace(",", ""); // remove comma

//   // Create date with year (for day name only)
//   const fullDate = new Date(`${dateNumber} ${monthName} 2025`);

//   if (isNaN(fullDate)) return rawDate;

//   // Day Names
//   const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
//   const dayName = days[fullDate.getDay()];

//   // KEEP ORIGINAL ordinal (2nd / 3rd / 4th)
//   const originalDate = rawDate.split(" ")[0]; // 2nd, 3rd, 11th etc.

//   return `${dayName}, ${originalDate} ${monthName}`;
// }

function formatDeliveryDate(dateStringWithSuffix) {
  if (!dateStringWithSuffix) return "";
  // console.log("Raw Date" , dateStringWithSuffix)

  const cleanDate = dateStringWithSuffix.replace(/(st|nd|rd|th)/g, '');

  const dateObject = new Date(cleanDate);

  if (isNaN(dateObject.getTime())) {
    return "Invalid Date";
  }

  // Get weekday
  const weekdayName = dateObject.toLocaleDateString('en-US', {
    weekday: 'long'
  });

  // Extract day + month from original string (without year)
  const match = dateStringWithSuffix.match(/^(\d+(?:st|nd|rd|th))\s+([A-Za-z]+)/);

  if (!match) return "Invalid Date";

  const dayWithSuffix = match[1];
  const monthShort = match[2].slice(0, 3); // Feb, Mar, etc.

  return `${weekdayName}, ${dayWithSuffix} ${monthShort}`;
}



function showError(msg) {
  inputContainer.addClass("container__error").css("animation", "shake 0.3s");

  pincodeCheckerError.html(`
    <div class="apiResponse">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <circle cx="9" cy="9" r="9" fill="#D80000" fill-opacity="1"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.77271 3.68182V10.2273H10.2273V3.68182H7.77271ZM7.77271 11.8636V14.3182H10.2273V11.8636H7.77271Z"
          fill="white"/>
      </svg>
      <span class="error-text" style="color:red;">${msg}</span>
    </div>
  `);

  locationIcon.attr({
    "fill": "#D80000",
    "fill-opacity": "1"
  });

}

const pincodeSearchButtonId = document.getElementById("pincodeSearch");

pincodeSearchButtonId.addEventListener("focus", function () {
    pincodeSearchButtonId.select();
});





// ===============================
// Initialize All
// ===============================
$(document).ready(function () {
  pincodeCheckerInit();
  pincodeCheckerEventInit();
  onQuantityPincodeCheck();
  onVariantChangePincodeCheck();
  onCheckoutButtonsInit();
  onclickScrollTopToInput();
  customddataEvent();
});
